// extracted by mini-css-extract-plugin
export default {"device":"index_device__rcsFD","box":"index_box__sTEKF"};